import React from "react";
import { withRouter } from "react-router";
import classes from "./Header.module.scss";
import Aux from "../../Aux/Aux";
import Logo from "../../../components/Logo/Logo";
import NavigationItems from "../../../components/NavigationItems/NavigationItems";
import NavigationOptions from "../../../components/NavigationOptions/NavigationOptions";
import { useLocation } from "react-router-dom";
import { loginScreensMapping } from "../../../container/LoginScreens/LoginScreens";

const Header = (props) => {
  const loginScreens = Object.keys(loginScreensMapping);

  const getLoginScreenButtons = () => {
    return (
      <div className="d-flex">
        {location.pathname !== "/login" ? (
          <button
            className="btn-secondary sign-up-button mr-4"
            onClick={() => props.history.push("/login")}
          >
            Login
          </button>
        ) : null}
        {location.pathname !== "/sign-up" ? (
          <button
            className="btn-primary get-started-button"
            onClick={() => props.history.push("/sign-up")}
          >
            Request Access
          </button>
        ) : null}
      </div>
    );
  };

  const location = useLocation();

  const isLoginScreen =
    loginScreens.filter((route) => location.pathname.startsWith(route)).length >
    0
      ? true
      : false;

  return (
    <Aux>
      <div
        className={[
          classes.Header,
          "d-flex px-7 mb-2",
          "align-items-center",
          "justify-content-between",
        ].join(" ")}
      >
        <div className="d-flex align-items-center">
          <Logo>Tikler</Logo>
          {!isLoginScreen ? (
            <NavigationItems place={"global"} navItems={props.navItems} />
          ) : null}
        </div>

        {!isLoginScreen ? <NavigationOptions /> : getLoginScreenButtons()}
      </div>
    </Aux>
  );
};
export default withRouter(Header);
